//
// client-exceptions-nav.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').directive('clientExceptionsNav', () => ({
        restrict: 'E',
        templateUrl: '/templates/partials/client-exceptions-nav.html',
    }));
}))();
